export default __webpack_public_path__ + "static/linktree size-794a055ac8fff2d5f160beeb5d5065fd.png";